export default __webpack_public_path__ + "static/media/osbre image.1e83d514.png";